import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import GoogleSignInButton from './GoogleSignInButton';
import './styles.css';

function LoginForm() {
  const { isAuthenticated, setIsAuthenticated, user, setUser, logout, loading, login } = useContext(AuthContext);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && user) {
      navigate('/');
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(username, password);
      navigate('/');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Prevents flash of login screen
  }

  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="main-content">
      <div className="login-form">
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button type="submit">Login</button>
        </form>
        <div className="forgot-password">
          <Link to="/forgot-password">Forgot Password?</Link>
        </div>
        <div className="signup-link">
          Don't have an account?{' '}
          <Link to="/signup" className="signup-link-text">Sign Up</Link>
        </div>
      </div>

      <div className="login-line"></div>
      <label className="login-or">
        <span>or</span>
      </label>
      <div className="login-line"></div>

      <div className="social-login">
        <div className="social-button">
          <GoogleSignInButton />
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
